import React from "react";
import { useParams } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout/MainLayout";

const CustomsData = () => {
  const { orgId } = useParams();
  const sessionToken = localStorage.getItem("session_token");

  const iframeUrl = `https://entropical.retool.com/embedded/public/3c4d0569-6ab5-41a5-923d-3e198f9a74ad?session_token=${sessionToken}&org_id=${orgId}`;

  return (
    <MainLayout>
      <div style={{ width: "100%", height: "100vh", border: "none" }}>
        <iframe
          src={iframeUrl}
          title="Control Tower"
          width="100%"
          height="100%"
          frameBorder="0"
        />
      </div>
    </MainLayout>
  );
};

export default CustomsData;
